<div class="widget-couriers-container">
    <h3 class="widget-couriers__title">
        {{'footer.corrieri' | T}}
    </h3>

    <div class="couriers-wrapper">
        @for(courier of couriers; track courier.id){
            <div class="couriers-img-wrapper">
                <a [href]="courier.url" target="_blank" rel="noopener" class="courier-link">
                    <img [src]="courier.img" [alt]="courier.name" class="courier-img img-fluid" loading="lazy">
                </a>
            </div>
        }
    </div>
        

</div>

